import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconSale = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" fill="none" {...props}>
    <path
      d="M12.6673 12.1182H12.6807M20.6673 20.1966H20.6807M22.0007 10.7718L11.334 21.543M30.0007 16.1574C30.0007 23.5934 24.0311 29.6215 16.6673 29.6215C9.30352 29.6215 3.33398 23.5934 3.33398 16.1574C3.33398 8.72142 9.30352 2.69336 16.6673 2.69336C24.0311 2.69336 30.0007 8.72142 30.0007 16.1574ZM13.334 12.1182C13.334 12.49 13.0355 12.7914 12.6673 12.7914C12.2991 12.7914 12.0007 12.49 12.0007 12.1182C12.0007 11.7464 12.2991 11.445 12.6673 11.445C13.0355 11.445 13.334 11.7464 13.334 12.1182ZM21.334 20.1966C21.334 20.5684 21.0355 20.8698 20.6673 20.8698C20.2991 20.8698 20.0007 20.5684 20.0007 20.1966C20.0007 19.8248 20.2991 19.5234 20.6673 19.5234C21.0355 19.5234 21.334 19.8248 21.334 20.1966Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconSale;
